<template>
  <div class="park">
    <div>
    <div class="park-btn">
      <el-button type="primary" size="mini" @click="updateDicDialog()">添加数据</el-button>
    </div>
    <div class="main-table">
      <el-table
        :data="dicList"
        border
        style="width: 100%">
        <el-table-column prop="id" label="ID"> </el-table-column>
        <el-table-column prop="username" label="用户名"> </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            {{scope.row.firstName}},{{scope.row.lastName}}
          </template>
        </el-table-column>
        <el-table-column label="角色">
          <template slot-scope="scope">
            {{scope.row.role?scope.row.role.name:''}}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">有效</el-tag>
            <el-tag type="danger" v-else>已失效</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号"> </el-table-column>
        <el-table-column label="创建日期">
          <template slot-scope="scope">
            <div>{{$dtime(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
          </template>
        </el-table-column>
        
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="updateDicDialog(scope.row)">修改</el-button>
            <!--<el-button type="text" size="mini" @click="deleteDicDialog(scope.row)">{{scope.row.isDelete == true ? '恢复':'删除'}}</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-bottom:30px;margin-top:20px;">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="dataArgs.total"
          :page-size="dataArgs.take"
          :current-page="dataArgs.skip/dataArgs.take+1"
          @current-change="changePage" style="float:right;">
        </el-pagination>
      </div>
    </div>
    </div>
    <el-dialog
      title="用户操作"
      :visible.sync="isUpdateShow"
      width="70%">
      <el-form ref="form" :model="dicEntity" label-width="110px">
        <el-form-item label="用户名">
          <el-input v-model="dicEntity.username"></el-input>
        </el-form-item>
        <el-form-item label="用户密码">
          <el-input v-model="dicEntity.password"></el-input>
        </el-form-item>
        <el-form-item label="First Name">
          <el-input v-model="dicEntity.firstName"></el-input>
        </el-form-item>
        <el-form-item label="Last Name">
          <el-input v-model="dicEntity.lastName"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="dicEntity.mobile"></el-input>
        </el-form-item>
        <el-form-item label="角色">
            <el-select v-model='dicEntity.roleId' clearable>
              <el-option v-for="(item,index) in roleList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model='dicEntity.status' >
            <el-option label="有效" :value="parseInt(1)"></el-option>
            <el-option label="失效" :value="parseInt(0)"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isUpdateShow = false">取 消</el-button>
        <el-button type="primary" @click="updateDic">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="!dicEntity.isDelete ? '删除字典':'恢复删除'"
      :visible.sync="isDeleteShow"
      width="50%">
      <span>确定要{{!dicEntity.isDelete ? '删除字典':'恢复删除'}}么？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDeleteShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteDic">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUsers, getRoles,getUserDictionaries,getPermissions,updateUser,addUser } from './user.gql'
import gql from "graphql-tag";
export default {
  name: 'dic',
  data () {
    return {
      dicEntity:{
        id:null,
        username:null,
        password:null,
        firstName:null,
        lastName:null,
        roleId:'user',
        mobile:null,
      },
      roleList:[],
      dicList:null,
      dataArgs:{
        take:20,
        skip:0,
        order:'-createTime',
        count:null,
      },
      isUpdateShow:false,
      isDeleteShow:false,
    }
  },
  created(){
    this.getUserList()
    this.getRoleList()
    this.getDicTypeList()
    this.getPermissionList();
  },
  methods:{
    getRoleList(){
      this.$global.GraphqlQuery(this,getRoles,{
        // Parameters
        // variables: this.dataArgs,
      }).then((res) => {
        this.roleList = res.data
      })
    },
    getUserList(){
      this.$global.GraphqlQuery(this,getUsers,this.dataArgs,
      ).then((res) => {
        this.dataArgs.total = res.total
        this.isUpdateShow = false
        this.dicList = res.data
      })
    },
    getPermissionList(){
      this.$global.GraphqlQuery(this,getPermissions,{
        // Parameters
      }).then((res) => {
        this.permissionList = res.data
      })
    },
    updateDicDialog(item){
      if(item){
        this.dicEntity = item
      }else {
        this.dicEntity.id = null
      }
      this.isUpdateShow = !this.isUpdateShow
    },
    changeTypeRadio(){
      this.dataArgs.skip = 0;
      this.getUserList()
    },
    changePage(val){
      this.dataArgs.skip = (val-1)*this.dataArgs.take
      this.getUserList()
    },
    getDicTypeList(){
      this.$global.GraphqlQuery(this,getUserDictionaries,{
        // Parameters
         type:'page_page',order:'+sort'
      }).then((res) => {
        this.pageList = res.data
      })
    },
    updateDic(){
      let {username,firstName,password,status,lastName,roleId,mobile} = this.dicEntity
      const subEntity = {username,firstName,password,status,lastName,roleId,mobile}
      if(this.dicEntity.id){
        this.$global.GraphqlMutation(this,updateUser,{
          // Parameters
            id:this.dicEntity.id,
            data: subEntity
        }).then(res=>{
          this.getUserList();
        })
      } else {
        this.$global.GraphqlMutation(this,addUser,{
          // Parameters
            data: subEntity
        }).then(res=>{
          this.getUserList();
        })
      }
    },
    deleteDicDialog(item){
      this.dicEntity = item
      this.isDeleteShow = !this.isDeleteShow
    },
    deleteDic(){
    this.$apollo.mutate({
        mutation: gql`mutation ($id: String!) {
          deleteDictionary(id: $id) {
            status
          }
        }`,
        // Parameters
        variables: {
          id: 1,
        },
      }).then((res) => {
        console.log(res)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.park{
  height: 100%;
}
.park-btn {
  margin: 10px;
}
.park-red {
  background-color: red;
  color:white;
  padding:5px;
}
.park-green{
  background-color: green;
  color: white;
  padding:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/management/User.vue